<template>
  <el-table
    :data="data"
    style="width: 100%"
  >
    <el-table-column
      prop="creatUserName"
      label="Create By"
      width="120"
    ></el-table-column>
    <el-table-column
      prop="createTime"
      label="Date Time"
      width="160"
    ></el-table-column>
    <el-table-column
      prop="approvalComments"
      label="Comments"
    ></el-table-column>
    <el-table-column
      prop="fileID"
      label="File Name"
    >
      <template slot-scope="scope">
        <a
          style="color: #0d94ff"
          @click="downLoadFile(scope.row)"
        >{{ scope.row.fileID && (scope.row.fileID.split('&$_$&')[0] + "." + scope.row.fileID.split('.')[1])}}</a>
      </template>
    </el-table-column>
    <el-table-column
      prop="approvalUserName"
      label="Next Action By"
      width="120"
    ></el-table-column>
    <el-table-column
      prop="approvalStatusString"
      label="Status"
    ></el-table-column>
  </el-table>
</template>
<script>
import { downloadFile, } from "@/utils/azure";
import { downloadAzureFile } from "@/api/system";
import { Loading } from 'element-ui';
export default {
  name: "HistoryList",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  methods: {
    downLoadFile (rowData) {
      if (rowData.fileID > "") {
        let loadingInstance = Loading.service({ fullscreen: true });
        downloadAzureFile({ azureFileName: rowData.fileID }).then(res => {
          downloadFile(res, rowData.fileID);
          this.$nextTick(() => {
            loadingInstance.close();
          });
        })
      } else {
        this.$message({
          message: "Please choose a file to download.",
          type: "error",
          showClose: true,
          duration: 5000
        });
      }
    }
  },
  mounted () {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HistoryList/index.vue